// extracted by mini-css-extract-plugin
export var card = "_4x-0";
export var content = "_4x-1";
export var contentLoading = "_4x-2";